module.exports = __webpack_public_path__ + "img/guaranteed-prize.2a913ce4.svg";